import { render, staticRenderFns } from "./GrainType.vue?vue&type=template&id=3b1bfdbb&scoped=true"
import script from "./GrainType.vue?vue&type=script&lang=js"
export * from "./GrainType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1bfdbb",
  null
  
)

export default component.exports